import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import React from 'react'
import { i18n } from '../../index'
import css from './marketQuestionDialog.css'
import MarketQuestionForm from './MarketQuestionForm'
import type { MarketQuestion } from './marketQuestionTypes'
type MarketQuestionDialogProps = {
  data: MarketQuestion | null | undefined
  isOpen: boolean
  onClose: (...args: Array<any>) => any
}

class MarketQuestionDialog extends React.PureComponent<MarketQuestionDialogProps> {
  render() {
    const { data, isOpen, onClose } = this.props
    return (
      <Dialog
        className={css.component}
        /* disableBackdropClick */
        open={isOpen}
        onClose={onClose}
        aria-labelledby='form-dialog-title'
      >
        <DialogTitle id='form-dialog-title'>
          {data && data.id
            ? i18n.t('admin.marketQuestion.title.editDialog')
            : i18n.t('admin.marketQuestion.title.createDialog')}
        </DialogTitle>
        <DialogContent>
          <MarketQuestionForm data={data} onSubmit={onClose} onCancel={onClose} />
        </DialogContent>
      </Dialog>
    )
  }
}

export default MarketQuestionDialog
